import Checkbox from 'components/form/fields/Checkbox/Checkbox';
import Dropdown from 'components/form/fields/Dropdown/Dropdown';
import SimpleTextInput from 'components/form/fields/SimpleTextInput';
import { AsyncDropdown } from './AsyncDropdown/AsyncDropdown';
import createDecorator from 'final-form-calculate';

export const formConfig = {
  fields: [
    {
      component: SimpleTextInput,
      isRequired: true,
      name: 'title',
      title: 'Title',
      translatable: true,
    },
    {
      component: Checkbox,
      name: 'isPublished',
      roles: ['admin', 'superadmin'],
      title: 'Is published',
    },
    {
      component: Dropdown,
      isRequired: true,
      name: 'type',
      options: [
        { value: 'category', label: 'Category' },
        { value: 'page', label: 'Article' },
        { value: 'parent', label: 'No' },
      ],
      title: 'Type',
    },
    {
      component: AsyncDropdown,
      isRequired: true,
      name: 'param',
      title: 'Slug',
    },
    {
      name: 'isDefault',
      title: 'Is default',
      customizedComponent: (thisProps: any) => {
        const initialValue = thisProps.initialValues.isDefault;
        const hasDefault = thisProps.menu.find((item: any) => item.isDefault);
        const isTopMenuItem = thisProps.menu.some(
          (item: any) => item.id === thisProps.initialValues.id,
        );
        return {
          component: Checkbox,
          isDisabled: hasDefault && !initialValue,
          hasTooltip: hasDefault && !initialValue,
          tooltipTitle: `${hasDefault?.title} is already marked as default. Only one item can be set as default.`,
          showInput: isTopMenuItem || !thisProps.initialValues.id,
        };
      },
    },
  ],
  title: (params: any) => {
    return params.initialValues.id ? 'Edit menu item' : 'Add menu item';
  },
  withPermission: true,
};

export const decorators = [
  createDecorator({
    field: 'type',
    updates: {
      param: (value: any, allValues: any, prevValues: any) => {
        if (!Object.prototype.hasOwnProperty.call(prevValues, 'type')) {
          return allValues?.param;
        }
        return value === 'parent' ? allValues?.param : '';
      },
    },
  }),
];
